/** 出庫來源類型 Badge／文案（SelectedPanel、SourcePickerDialog 共用）。 */
export function getOutboundSourceTypeMeta(sourceType) {
  if (sourceType === 'PENDING_ALLOCATION') {
    return {
      shortLabel: '待處理',
      variant: 'secondary',
      badgeClassName: '',
    };
  }

  return {
    shortLabel: '庫存',
    variant: 'outline',
    badgeClassName: (
      'border-primary-500 bg-primary-50/90 text-primary-900 font-medium shadow-xs'
    ),
  };
}
